import React from 'react'
import propTypes from 'prop-types'
import classNames from 'classnames'
import WbUtils from '../../utils/whiteboard'
import Icon from '../Icon'
import './index.less'

const defaultColor = [
  '#C74142',
  '#C9892D',
  '#FFD640',
  '#FFAA40',
  '#FF7540',
  '#FF4040',
  '#FF40AE',
  '#ED40FF',
  '#9E40FF',
  '#5840FF',
  '#408BFF',
  '#40DAFF',
  '#36BC9D',
  '#06DB06',
  '#484848',
]
const defaultBrush = [
  'icon-test', 
  'icon-test4', 
  'icon-test1', 
  'icon-test5', 
  'icon-test2', 
  'icon-test11', 
  'icon-test3', 
  'icon-test13', 
  'icon-test6', 
  'icon-test8', 
  'icon-test14', 
  'icon-test7', 
  'icon-test12', 
  'icon-test9', 
  'icon-test10',
]

class BigWhiteboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      canvasColor: defaultColor[0],
      canvasWidth: 10,
      canvasEraserWidth: 50,
      type: 'pen',
    }
  }

  componentDidMount() {
    this.whiteboard = new WbUtils({
      id: 'bigWhiteboard',
      disabled: this.props.disabled,
      allowDraw: this.props.allowDraw,
      color: this.state.canvasColor,
      width: this.props.style.width - 60,
      height: this.props.style.height - 60,
    })
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.style.width !== nextProps.style.width ||
      this.props.style.height !== nextProps.style.height
    ) {
      this.canvasSize({
        width: nextProps.style.width - 60,
        height: nextProps.style.height - 60,
      })
    }
  }

  canvasSize = (style) => {
    this.whiteboard.updateScreenSize(style)
  }

  canvasUndo = () => {
    this.whiteboard.undo()
  }

  canvasClear = () => {
    this.whiteboard.clear()
  }

  canvasColorChoose = (color) => {
    this.setState({ canvasColor: color, type: 'pen' })
    this.whiteboard.typeChoose('pen')
    this.whiteboard.widthChoose(this.state.canvasWidth)
    this.whiteboard.colorChoose(color)
  }

  canvasTypeChoose = (type) => {
    this.setState({ type })
    this.whiteboard.typeChoose(type)
    this.whiteboard.widthChoose(type === 'pen' ? this.state.canvasWidth : this.state.canvasEraserWidth)
  }

  canvasWidthChoose = (width) => {
    this.setState({
      canvasWidth: this.state.type === 'pen' ? width : this.state.canvasWidth,
      canvasEraserWidth: this.state.type === 'eraser' ? width : this.state.canvasEraserWidth,
    })
    this.whiteboard.widthChoose(width)
  }

  render() {
    const brushStyle = { width: Math.floor(this.props.style.width * (1157 / 1920)), height: Math.floor(this.props.style.width * (1157 / 1920) * (157 / 1157)) }
    const canvasWidth = this.state.type === 'pen' ? this.state.canvasWidth : this.state.canvasEraserWidth
    return (
      <div
        className="big-whiteboard-component-container"
        id="bigWhiteboardBg"
        style={Object.assign({}, this.props.style, {
          display: this.props.visible ? 'block' : 'none'
        })}
      >
        <div
          className="whitebord-box"
          style={{ width: this.props.style.width, height: this.props.style.height }}
        >
          <canvas
           className="whiteborad"
           id="bigWhiteboard"
           style={{
             width: this.props.style.width - 60,
             height: this.props.style.height - 60,
           }}
          />
        </div>
        <div className="whiteboard-tool">
          <a className="tool-clear" onClick={this.canvasClear}>
            <Icon type="quanbuqingchu" />
          </a>
          <a className="tool-undo" onClick={this.canvasUndo}>
            <Icon type="chexiaoshangyibu" />
          </a>
          <a className={classNames({
            'tool-width': true,
            'canvas-tool': true, 
            'canvas-tool-select': canvasWidth === 10,
          })} onClick={() => (this.canvasWidthChoose(10))}>
            <Icon type="juxing" />
          </a>
          <a className={classNames({
            'tool-width': true,
            'canvas-tool': true, 
            'canvas-tool-select': canvasWidth === 20,
          })} onClick={() => (this.canvasWidthChoose(20))}>
            <Icon type="juxingcopy" />
          </a>
          <a className={classNames({
            'tool-width': true,
            'canvas-tool': true, 
            'canvas-tool-select': canvasWidth === 50,
          })} onClick={() => (this.canvasWidthChoose(50))}>
            <Icon type="juxingcopy1" />
          </a>
        </div>
        <div className="whiteboard-bursh" style={{
          width: brushStyle.width,
          height: brushStyle.height,
          marginLeft: `-${brushStyle.width / 2}px`
        }}>
          {
            Array(15).fill(0).map((item, index) => (
              <div
                className="whiteboard-bursh-item"
                key={index}
                style={{ bottom: this.state.type === 'pen' && this.state.canvasColor === defaultColor[index] ? `-${brushStyle.height / 10}px` : `-${brushStyle.height / 3}px` }}
                onClick={() => (this.canvasColorChoose(defaultColor[index]))}
              >
                <Icon
                  style={{ width: Math.floor(brushStyle.width / 15), height: brushStyle.height }}
                  type={defaultBrush[index]}
                />
              </div>
            ))
          }
          <div
            className="whiteboard-bursh-item whiteboard-eraser-item"
            key={16}
            style={{ bottom: this.state.type === 'eraser' ? `-${brushStyle.height / 10}px` : `-${brushStyle.height / 3}px` }}
            onClick={() => (this.canvasTypeChoose('eraser'))}
          >
            <Icon style={{ width: Math.floor(brushStyle.width / 15), height: brushStyle.height }} type="eraser" />
          </div>
        </div>
      </div>
    )
  }
}

BigWhiteboard.propTypes = {
  /**
   * 是否显示大白板
   */ 
  visible: propTypes.bool,
  /**
   * 大白板的样式，主要是宽度和高度
   */
  style: propTypes.object,
  /**
   * 是否禁止画板初始化
   */
  disabled: propTypes.bool,
  /**
   * 是否允许画画
   */
  allowDraw: propTypes.bool,
}

BigWhiteboard.defaultProps = {
  visible: true,
  style: {
    width: 1000,
    height: 500,
  },
  disabled: false,
  allowDraw: true,
}

export default BigWhiteboard



// WEBPACK FOOTER //
// ./src/components/BigWhiteboard/index.js